<template>
  <div style="position: relative;min-height: 100vh;padding-bottom: 100px;">
    <Header class="is-uppercase has-text-weight-bold" />
    <div style="min-height: 75vh;">
      <slot></slot>
    </div>
    <Footer class="is-uppercase has-text-weight-bold" style="width: 100%;bottom: 0px;left:0;" />
  </div>
</template>

<script>
import Header from '@/components/LangGG/Header'
import Footer from '@/components/LangGG/Footer'

export default {
  name: 'LayoutGG',
  components: {
    Header,
    Footer
  }
}
</script>




// WEBPACK FOOTER //
// src/layouts/GG.vue